// Extracts the current site's real header/footer chrome (everything outside
// the top-level <main> on the org's home page) so newly generated pages
// (e.g. a Deal Board listing page) can be wrapped in it instead of looking
// like a disconnected, unbranded page. There's no live "template" concept in
// this app — each page just bakes its own copy of header/nav/footer HTML in
// at creation time (see dreamxTemplate.js's shell()) — so matching the site
// means literally copying the home page's real chrome, not referencing some
// named template.
//
// Returns null if the home page doesn't have a top-level <main> to split on
// (e.g. a hand-built site with a different structure) — callers should fall
// back to a standalone page in that case rather than guessing.
export function extractSiteChrome(editor) {
  try {
    const mainPage = editor.Pages.getMain ? editor.Pages.getMain() : null;
    const rootComponent = mainPage?.getMainComponent?.();
    const children = rootComponent?.components?.().models;
    if (!children || !children.length) return null;

    const mainIndex = children.findIndex(
      (c) => (c.get('tagName') || '').toLowerCase() === 'main'
    );
    if (mainIndex === -1) return null;

    const htmlOf = (list) =>
      list.map((c) => editor.getHtml({ component: c }) || '').join('\n');

    return {
      headerHtml: htmlOf(children.slice(0, mainIndex)),
      footerHtml: htmlOf(children.slice(mainIndex + 1)),
    };
  } catch (err) {
    console.warn('⚠️ Failed to extract site chrome:', err.message);
    return null;
  }
}
